import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="safe-px grid min-h-dvh place-items-center bg-black text-center text-white">
      <div>
        <p className="text-divergent-yellow">404</p>
        <h1 className="mt-2 text-3xl font-black">No encontramos esa pantalla</h1>
        <Link
          to="/"
          className="mt-6 inline-flex min-h-10 items-center justify-center rounded bg-divergent-yellow px-4 text-sm font-semibold text-black transition hover:bg-yellow-300"
        >
          Volver al feed
        </Link>
      </div>
    </main>
  );
}
